'use strict';

module.exports = require('./Slider');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.5.1.3@rc-slider/lib/index.js
 ** module id = 526
 ** module chunks = 0
 **/